import { bool, object, string } from 'yup';

const UrlSchema = string().url();
const UsernameSchema = string().test('is-username', '', value => value.startsWith('@'));

const GroupSchema = object().shape({
  title: string().required(),
  content_approval_type: string().required(),
  allow_user_posts: bool().required(),
  read_only: bool().required(),
  color: string().required(),
  icon_color: string().required(),
  icon: string().required(),
  image: object().nullable(true),
  department_id: string().nullable(true),
  location_id: string().nullable(true),
  is_private: bool(),
});

export { GroupSchema, UrlSchema, UsernameSchema };
